export default __webpack_public_path__ + "static/gilroy-semibold-1e202881f4eba6fa27075cc1ff021a47.woff2";